shadow$provide[320] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, PrimitiveFactory:{enumerable:true, get:function() {
  return PrimitiveFactory;
}}});
class PrimitiveFactory {
  constructor(definitions, context) {
    this.context = context;
    this.classes = definitions.Classes;
    this.helpers = definitions.Helpers;
  }
  getTypes() {
    return Object.keys(this.classes);
  }
  make(type, options, binds = null) {
    if (options == null) {
      options = {};
    }
    const klass = this.classes[type];
    if (klass == null) {
      throw new Error(`Unknown primitive class \`${type}\``);
    }
    const node = new klass.model(type, klass.defaults, options, binds, klass, this.context.attributes);
    new klass(node, this.context, this.helpers);
    return node;
  }
}

};